<template>
  <div class="PageFooter">
    <span class="PageFooter-item PageFooter-item--ubiflow">
      {{ $t("layouts.offeredBy") }}
      <a :href="website" target="_blank" rel="noopener">{{ $t("layouts.ubiflow") }}</a>
    </span>
    <el-divider direction="vertical" />
    <span class="PageFooter-item">{{new Date().getFullYear()}} ©</span>
    <el-divider direction="vertical" />
    <span class="PageFooter-links">
      <span class="PageFooter-item">
        <a :href="legalNotices" target="_blank" rel="noopener">{{ $t("layouts.legalNotice") }}</a>
      </span>
      <el-divider direction="vertical" />
      <span class="PageFooter-item">
        <a :href="'docs/conditions_generales_de_vente_de_diffusion_03_2025.pdf'" target="_blank" rel="noopener">{{ $t("layouts.conditionsOfSaleOfDiffusion") }}</a>
      </span>
      <el-divider direction="vertical" />
      <span class="PageFooter-item">
        <a :href="'docs/conditions_generales_de_vente_de_contact_manager_03_2025.pdf'" target="_blank" rel="noopener">{{ $t("layouts.conditionsOfSaleOfContactManager") }}</a>
      </span>
      <el-divider direction="vertical" />
      <span class="PageFooter-item">
        <a :href="'docs/conditions_generales_de_vente_de_social_manager_03_2025.pdf'" target="_blank" rel="noopener">{{ $t("layouts.conditionsOfSaleOfSocialManager") }}</a>
      </span>
    </span>
  </div>
</template>

<script>
import { Divider } from 'element-ui'

export default {
  name: 'PageFooter',
  inject: ['browserContext'],
  components: {
    ElDivider: Divider
  },
  computed: {
    website () {
      return processEnvConfig.VUE_APP_UBIFLOW_WEBSITE_URL
    },
    legalNotices () {
      return processEnvConfig.VUE_APP_LEGAL_NOTICES_URL
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.PageFooter {
  @extend .mb-5;

  font-size: $font-size-sm;
  color: $black;

  &-item {
    text-align: left;
    a {
      color: $black;
    }

    &--ubiflow {
      a {
        @extend .font-weight-bold;
      }
    }
  }

  .el-divider {
    background: $black;
  }

  @include media-breakpoint-up(md) {
    background: url(~@/assets/footer-logo.png);
    background-position: center top;
    background-repeat: no-repeat;
    padding-top: 44px + map-get($spacers, 3); // hauteur du logo + petite marge;
    margin-top: (44px + map-get($spacers, 3)) * -1 + map-get($spacers, 5);
  }
  @include media-breakpoint-down(sm) {
    text-align: left;
    line-height: $font-size-base * 1.5;

    width: 100%;
    & > &-item {
      display: block;
    }
    > .el-divider {
      display: none;
    }
  }
}
</style>
